import './bootstrap';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

window.Swiper = Swiper;

import {Alpine, Livewire} from '../../../../vendor/livewire/livewire/dist/livewire.esm';

import {hide, animateFrom, canEnableSwiperLoop} from './utils';

window.canEnableSwiperLoop = canEnableSwiperLoop;

gsap.registerPlugin(ScrollTrigger);


import dropdown from './dropdown';
import menu from './menu';
import PriceRangeSlider from './price-range-slider';
import ProductImagesCarousel from './product-images-carousel';
import ProductsCarousel from './products-carousel';
import CollectionsCarousel from './collections-carousel';
import CategoriesCarousel from './categories-carousel';
import CorporateCarousel from './corporate-carousel';
import ProductRecommendations from './product-recommendations';
import AboutImagesCarousel from './about-images-carousel';
import FeaturedCategoryCarousel from './featured-category-carousel';
import FeaturedCollectionCarousel from './featured-collection-carousel';
import RelatedProductsCarousel from './related-products-carousel';
import ComplementaryProductsCarousel from './complementary-products-carousel';
import initPresentationGallery from './presentation-gallery';
import initCollectionHeroTrio from './collection-hero-trio';
import './gtm-form-tracking';

Alpine.data('menu', menu);
Alpine.data('dropdown', dropdown);
Alpine.data('priceRangeSlider', PriceRangeSlider);
Alpine.data('productImagesCarousel', ProductImagesCarousel);
Alpine.data('productsCarousel', ProductsCarousel);
Alpine.data('collectionsCarousel', CollectionsCarousel);
Alpine.data('categoriesCarousel', CategoriesCarousel);
Alpine.data('corporateCarousel', CorporateCarousel);
Alpine.data('productRecommendations', ProductRecommendations);
Alpine.data('aboutImagesCarousel', AboutImagesCarousel);
Alpine.data('featuredCategoryCarousel', FeaturedCategoryCarousel);
Alpine.data('featuredCollectionCarousel', FeaturedCollectionCarousel);
Alpine.data('relatedProductsCarousel', RelatedProductsCarousel);
Alpine.data('complementaryProductsCarousel', ComplementaryProductsCarousel);

Alpine.store('sidebars', {
    showMenu: false,
    showQuickFilter: false,
    showQuickSearch: false,
    showOverlay: false,
    toggleMenu() {
        this.showMenu = !this.showMenu;
        this.showOverlay = !this.showOverlay;
    },
    toggleQuickFilter() {
        this.showQuickFilter = !this.showQuickFilter;
        this.showOverlay = !this.showOverlay;
    },
    toggleQuickSearch() {
        this.showQuickSearch = !this.showQuickSearch;
        this.showOverlay = !this.showOverlay;
    },
    hideSidebars() {
        this.showMenu = false;
        this.showQuickSearch = false;
        this.showOverlay = false;
    },
});

const revealElements = () => {
    let elements = document.querySelectorAll('.gs_reveal');
    let delay = 0;

    elements.forEach((elem, index) => {
        hide(elem);

        ScrollTrigger.create({
            trigger: elem,
            onEnter: function () {
                if (index++ % 4 === 0) {
                    // Reset the initial value after every four iterations
                    delay = 0;
                }

                delay += 0.15;

                animateFrom(elem, 1, delay);
            },
            onEnterBack: function () {
                animateFrom(elem, -1, 0);
            },
            onLeave: function () {
                hide(elem);
            },
        });
    });
};
revealElements();


window.reshape = window.reshape || [];

window.reshape.forEach((payload) => {
    console.log('[DATA Reshape]', payload);
});

const reshapePush = Array.prototype.push;

window.reshape.push = function (...items) {
    items.forEach((payload) => console.log('[DATA Reshape]', payload));

    return reshapePush.apply(this, items);
};

window.addEventListener('pushToDataLayer', function (event) {
    if (! window.dataLayerAllowsTracking) {
        return;
    }

    if (dataLayer) {
        const data = JSON.parse(event.detail);
        dataLayer.push({ecommerce: null});
        dataLayer.push(data);
    }
});

window.addEventListener('pushToMarketer', function (event) {
    if (! window.marketerAllowsTracking) {
        return;
    }

    if (dataLayer) {
        const data = JSON.parse(event.detail);
        dataLayer.push({ecommerce: null});
        dataLayer.push({user_data: null});
        dataLayer.push(data);
    }

});

window.addEventListener('pushToReshape', function (event) {
    if (! window.dataReshapeAllowsTracking) {
        console.log('[DATA Reshape] pushToReshape skipped — marketing consent not granted', event.detail);

        return;
    }

    const rawPayload = Array.isArray(event.detail)
        ? event.detail[0]
        : (typeof event.detail === 'string' ? event.detail : Object.values(event.detail ?? {})[0]);

    if (!rawPayload) {
        console.warn('[DATA Reshape] pushToReshape received empty payload', event.detail);

        return;
    }

    try {
        const parsed = JSON.parse(rawPayload);
        const payloads = parsed?.event ? [parsed] : parsed;

        if (! Array.isArray(payloads)) {
            console.warn('[DATA Reshape] pushToReshape received invalid payload', event.detail);

            return;
        }

        payloads.forEach((payload) => window.reshape.push(payload));
    } catch (error) {
        console.error('[DATA Reshape] Failed to parse pushToReshape payload', rawPayload, error);
    }
});

const pushSearchDataToGTM = data => {
    if (dataLayer) {
        const searchData = JSON.parse(data);
        dataLayer.push({search_term: null});
        dataLayer.push(searchData);
    }
};

window.addEventListener('pushSearchToDataLayer', function (event) {
    setTimeout(() => {
        pushSearchDataToGTM(event.detail);
    }, 3000);
});


const pushUserDataToGTM = data => {
    if (dataLayer) {
        const userData = JSON.parse(data);
        dataLayer.push({user_data: null});
        dataLayer.push(userData)
    }
};


window.addEventListener('pushUserDataToDataLayer', function (event) {
    pushUserDataToGTM(event.detail);
});

window.addEventListener('pushSearchToMarketer', function (event) {
    setTimeout(() => {
        pushSearchDataToGTM(event.detail);
    }, 3000);
});


window.Alpine = Alpine;

Livewire.start();

// Initialize presentation gallery lightbox
document.addEventListener('DOMContentLoaded', () => {
    initPresentationGallery();
    initCollectionHeroTrio();
});
